export default class AirQualityMeasurements {
  constructor(element) {
    this.el = element
    this.tablist = this.el.querySelector('[role="tablist"')
    this.station = this.el.dataset.station
    this.locale = this.el.dataset.locale ? this.el.dataset.locale : 'fr'
    this.isDataFetched = false
    this.errorEl = this.el.querySelector('.js-tab-measurements-error')
    this.loaderEl = this.el.querySelector('.js-tab-measurements-loader')
    this.isFirstLoad = true

    if (this.station) {
      this.yearList = this.el.querySelector('.js-tab-measurements-year-select')
      this.tabpanel = ''
      this.init()
    }
  }

  init() {
    this.tablist.addEventListener('TabChange', this.handleTabChange.bind(this))

    if (this.yearList) {
      this.year = this.yearList[0].value
      this.yearList.addEventListener('change', this.handleYearChange.bind(this))
    }

    if (this.el) {
      this.setupIntersectionObserver()
    }
  }

  setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.isDataFetched) {
              this.updateAirQualityMeasurements()
              this.isDataFetched = true
            }
            observer.disconnect()
          }
        })
      },
      { threshold: 0.1 },
    )

    if (this.el) {
      observer.observe(this.el)
    }
  }

  async handleTabChange(event) {
    const tab = event.detail.tab
    this.tabpanel = event.detail.tabpanel
    if (tab.classList.contains('js-tab-measurements') && !this.isDataFetched) {
      this.updateAirQualityMeasurements()
      this.isDataFetched = true
    }
  }

  async handleYearChange(event) {
    this.year = event.target.value
    this.updateAirQualityMeasurements()

    const tabPolite = this.el.querySelector('.js-tab-measurements-polite')
    if (tabPolite && this.year) {
      tabPolite.innerHTML = this.year
    }
  }

  async updateAirQualityMeasurements() {
    try {
      const tabContent = this.el.querySelector('.js-tab-measurements-content')
      tabContent.style.display = 'block'
      this.errorEl.style.display = 'none'
      this.showLoader()
      const measurements = await this.fetchAirQualityMeasurement()
      if (measurements) {
        this.updateTabContent(measurements)
      }
      this.loaderEl.classList.add('hidden')

      if (tabContent) {
        tabContent.style.display = 'block'
      }

      if (this.isFirstLoad) {
        this.scrollToEnd()
        this.isFirstLoad = false
      } else {
        this.scrollToStart()
      }
    } catch (error) {
      this.handleError()
      this.loaderEl.classList.add('hidden')
    }
  }

  async fetchAirQualityMeasurement() {
    const response = await fetch(
      `${window.location.origin}/wp-json/api/v1/air-quality/${this.station}/measurement_history?year=${this.year}&locale=${this.locale}`,
      {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
        },
      },
    )

    const responseJson = await response.json()

    if (!responseJson.success) {
      throw new Error('API_ERROR')
    }

    return responseJson.data[0]
  }

  async updateTabContent(data) {
    const tabDiagram = this.el.querySelector('.js-tab-measurements-diagram')
    if (tabDiagram) {
      tabDiagram.innerHTML = this.getDiagramContent(data)
    }
  }

  getDiagramContent(data) {
    const measurements = Array.isArray(data[0]) ? data[0] : data

    const tabDiagram = measurements.map((item) => {
      let itemStatus = ''
      let itemStatusText = ''

      if (item.pm25 > 30) {
        itemStatus = 'red'
        itemStatusText =
          window.ICL_LANGUAGE_CODE == 'en'
            ? 'High measurement'
            : 'Mesure élevée'
      }

      if (item.month == 'juin') {
        item.month = 'jun'
      }

      return `
        <li class="block-air-quality__diagram__x__item block-air-quality__diagram__x__item--${itemStatus}">
          <div class="block-air-quality__diagram__x__row">
            <div class="block-air-quality__diagram__x__bar-number">
              ${item.pm25} <span class="visuallyhidden"> ${window.ICL_LANGUAGE_CODE == 'en' ? 'on 60' : 'sur 60'}, ${itemStatusText}</span>
            </div>
            <div class="block-air-quality__diagram__x__bar block-air-quality__diagram__x__bar--${item.pm25}"></div>
          </div>
          <div class="block-air-quality__diagram__x__number">
            ${item.day}
            <span aria-hidden="true">${item.month.slice(0, 3)}</span>
            <span class="visuallyhidden">${item.month}</span>
          </div>
        </li>
      `
    })

    return tabDiagram.join('')
  }

  handleError() {
    const tabContent = this.el.querySelector('.js-tab-measurements-content')

    if (tabContent) {
      tabContent.style.display = 'none'
    }

    this.errorEl.style.display = 'block'
  }

  showLoader() {
    const tabContent = this.el.querySelector('.js-tab-measurements-content')
    if (tabContent) {
      tabContent.style.display = 'none'
    }

    this.loaderEl.classList.remove('hidden')

    const tabDiagram = this.el.querySelector('.js-tab-measurements-diagram')
    if (tabDiagram) {
      tabDiagram.innerHTML = ''
    }
  }

  scrollToEnd() {
    const contentWrapper = this.el.querySelector('.simplebar-content-wrapper')

    if (contentWrapper) {
      contentWrapper.scrollLeft = contentWrapper.scrollWidth
    }
  }

  scrollToStart() {
    const contentWrapper = this.el.querySelector('.simplebar-content-wrapper')

    if (contentWrapper) {
      contentWrapper.scrollLeft = 0
    }
  }
}
